import React, { Component } from 'react';
import { 
    TableStore,
    connect,
    useStore, 
    useResize, 
    useIndex, 
    useCheckbox, 
    useSort, 
    useExpandRow,
    useTreeTable,
    useFilter,
    usePagination,
    useErrorTips,
    useRowClick,
    useLocation,
    useContextMenu,
    useCellSelect,
    useHotKey,
    useDOM,
    useGroupSort,
    useFieldSetting,
    useCardTable,
    useCache,
    useStyle,
    useOprCol,
} from "@platform/table-core";
import BaseCardTable from './components/BaseCardTable';
import CardTableModal from './components/CardTableModal';
import './index.less';
import { getRelationTables } from '../utils/util';

let hookExtensions = [
    connect,
    useHotKey, 
    useStore, 
    useResize,
    useIndex,
    useCheckbox,
    useExpandRow,
    useRowClick,
    useTreeTable,
    useSort,
    useCellSelect,
    useDOM,
    useCardTable,
    usePagination,
    useCache,
    useFilter,
    useLocation,
    useGroupSort,
    useFieldSetting,
    useContextMenu,
    useStyle,
    // useCopy,
    useErrorTips,
    useOprCol,
];

// 主要作用为：创建UI、分发Store
// TODO:优化：组件拆分
class CardTableWithModal extends Component {
    componentDidMount() {
        let { stores, relation } = this.props;
        relation.dependence.forEach(moduleId => {
            stores[moduleId].getInstance().register('CardTableWithModal', this);
        });
    }

    componentDidUpdate() {
        let { stores, relation } = this.props;
        relation.dependence.forEach(moduleId => {
            stores[moduleId].getInstance().register('CardTableWithModal', this);
        });
    }

    render() {
        let { id, stores, relation } = this.props,
            tables = getRelationTables.call(this, relation),
            store = stores[id],
            open = !!store.getCardTableModalInfo().open;

        return <>
            <BaseCardTable {...this.props} _tables={tables} />
            {open && <CardTableModal {...this.props} />}
        </>;
    }

    componentWillUnmount () {
        let { stores, relation } = this.props;
        relation.dependence.forEach(moduleId => {
            stores[moduleId].getInstance().unregister('CardTableWithModal', this);
        });
    }
}

CardTableWithModal.displayName = 'CardTable';
CardTableWithModal.useCardTable = function () {
    let store = new TableStore(hookExtensions);
    return store.getAllHooks();
};

export default CardTableWithModal;